<template>
  <div>
    <animation-loading-whale
      v-show="!isShowPage"
      :center="true"
      :loading="!isShowPage"
      class="whale-wrap"
    ></animation-loading-whale>
    <div v-show="isShowPage" class="home-page-wrp">
      <!-- 用户被禁 -->
      <template v-if="basicInfoDisabled">
        <div class="basic-info-disabled">
          <img src="~images/platform/homepage/hp-basic-disabled.png" alt="" />
        </div>
      </template>

      <template v-else>
        <homepageHeaderTest
          v-if="$platform.isYixinliApp || $platform.isZiXunApp"
          ref="Header"
          :currentTab="currentTab"
          :abTestV3_5="abTestHomepageV3_5"
          @follow="toggleFollow"
          @share="share"
        ></homepageHeaderTest>

        <div
          v-if="isFromSmartRecommend && recommendTeacherList.length"
          class="recommend-zx recommend-zx-test"
          :style="{
            'padding-top':
              $platform.isYixinliApp || $platform.isZiXunApp
                ? '2.4rem'
                : '0.2rem'
          }"
        >
          <div class="title">
            <img src="~images/platform/homepage/icon-recommendZX.png" alt="" />
            推荐咨询师
          </div>
          <div ref="zxsListWrap" class="zxs-list-wrap">
            <ul>
              <li
                v-for="({ user_id, name, avatar },
                index) in recommendTeacherList.slice(0, 10)"
                :key="user_id"
                @click="changeZXS(user_id, index)"
                ref="zxs"
              >
                <img
                  :src="avatar | imgZip(200)"
                  alt=""
                  :class="{ active: $route.params.userId === user_id }"
                />
                <p class="name">{{ name }}</p>
              </li>
              <li class="btn divider" @click="resetSmartRecommend">
                <div class="top">
                  <img src="~images/platform/homepage/icon-reset.png" alt="" />
                </div>
                <span>重新匹配</span>
              </li>
              <li class="btn" @click="toHeCong">
                <div class="top">
                  <img src="~images/platform/homepage/icon-kefu.png" alt="" />
                </div>
                <span>人工推荐</span>
              </li>
            </ul>
          </div>
        </div>

        <!-- 使用oss的高斯模糊 -->
        <img
          v-if="parsedAvatar && !hideBgMask"
          class="bg-mask"
          :src="parsedAvatar"
          alt=""
        />
        <div class="before-mask" :class="{ abTestV3_5: hideBgMask }"></div>
        <!-- 添加一个白色蒙层，确保底部的高斯模糊不会漏出来 -->
        <div class="white-mask" :style="{ top: mixinMaskTop }"></div>

        <div class="main-content">
          <banner
            v-if="isShowPage"
            @showImgViewer="handleShowImgViewer"
            :abTestV3_5="abTestHomepageV3_5"
          />
          <div class="content-inner content-inner-new" id="js-content-inner">
            <personInfo
              v-if="abTestHomepageV3_5"
              @updated="mixinUpdateHeight"
              @showImgViewer="handleShowImgViewer"
              @openSharePosterModal="openSharePosterModal"
              @follow="toggleFollow"
              @letter="sendLetter"
            />
            <div v-else>
              <!-- 有咨询和倾听两个身份 -->
              <zxpersonInfo
                v-if="isConsultTeacher || isQingtingTeacher"
                @updated="mixinUpdateHeight"
                @showImgViewer="handleShowImgViewer"
                @openSharePosterModal="openSharePosterModal"
              />
              <!-- 普通用户 -->
              <normalPersonInfo
                v-else
                @updated="mixinUpdateHeight"
                @follow="toggleFollow"
                @showImgViewer="handleShowImgViewer"
                @letter="sendLetter"
              />
            </div>
            <ad
              v-if="isConsultTeacher || isQingtingTeacher"
              name="zixun-teach-bottom"
              qingsuName="qingsu-teach-bottom"
              trackName="newprofilepages_banner_click"
              @initFinish="mixinUpdateHeight"
            />

            <workroomForExpert></workroomForExpert>

            <div class="content-inner-2">
              <tabbar
                :scrollDirection="scrollDirection"
                :tabList="mixinTabList"
                :showZxTabsDistance="mixinShowZxTabsDistance"
                @tabChange="calcHeights"
                ref="Tabbar"
              >
              </tabbar>

              <div class="all-list-wrap" v-if="nullTabbar">
                <!-- 服务tab -->
                <div
                  class="service-list-outer"
                  v-show="currentTab.name === 'service'"
                >
                  <ul
                    class="service-type-list"
                    v-if="serviceClassifys.length > 1"
                  >
                    <li
                      class="service-type"
                      :class="{ active: currentClassify.type === t.type }"
                      v-for="t in serviceClassifys"
                      :key="t.name"
                      @click="onTypeChange(t)"
                    >
                      {{ t.name }}
                    </li>
                  </ul>
                  <zxServiceList
                    v-show="currentClassify.type === 'consult'"
                    ref="ServiceList"
                    :showZxTabsDistance="mixinShowZxTabsDistance"
                    :scrollDirection="scrollDirection"
                    @toRate="toRate"
                  ></zxServiceList>
                  <serviceList
                    v-show="currentClassify.type === 'psychic'"
                  ></serviceList>
                </div>
                <template v-if="getIsShowPanel('qingsu')">
                  <div
                    v-show="currentTab.name === 'qingsu'"
                    class="service-list-outer"
                  >
                    <qsServiceList
                      ref="QsServiceList"
                      :showQsTabsDistance="
                        Math.max(
                          mixinShowZxTabsDistance,
                          mixinShowQsTabsDistance
                        )
                      "
                      :scrollDirection="scrollDirection"
                      @toRate="toRate"
                    />
                  </div>
                </template>
                <!-- 评价tab -->
                <template v-if="getIsShowPanel('evaluate')">
                  <commonRateList
                    v-show="currentTab.name === 'evaluate'"
                    ref="EvaluateList"
                    :scrollDirection="scrollDirection"
                    :showZxTabsDistance="mixinShowZxTabsDistance"
                  />
                </template>
                <!-- 动态tab -->
                <dynamicList
                  v-show="currentTab.name === 'dynamic'"
                  ref="DynamicList"
                  :scrollDirection="scrollDirection"
                ></dynamicList>

                <!-- 问答tab -->
                <qaList
                  v-show="currentTab.name === 'qa'"
                  ref="QaList"
                  :scrollDirection="scrollDirection"
                ></qaList>

                <!-- FMtab -->
                <fmList
                  v-show="currentTab.name === 'fm'"
                  ref="FmList"
                  :scrollDirection="scrollDirection"
                ></fmList>

                <!-- 文章tab -->
                <articleList
                  v-show="currentTab.name === 'article'"
                  ref="ArticleList"
                  :scrollDirection="scrollDirection"
                ></articleList>

                <!-- 故事tab -->
                <storyList
                  v-show="currentTab.name === 'story'"
                  ref="StoryList"
                  :scrollDirection="scrollDirection"
                ></storyList>
              </div>

              <!-- 新用户空状态 -->
              <div class="null-state" v-else>
                <img
                  class="null-img"
                  src="~images/platform/homepage/icon-null.png"
                  alt=""
                />
                <span class="null-tip">暂无内容</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 分享海报 -->
        <Posters ref="posters"></Posters>

        <bottomBar
          :currentClassify="currentClassify"
          :toZxOrderBtnColor="toZxOrderBtnColor"
          @follow="toggleFollow"
          @letter="sendLetter"
        ></bottomBar>

        <imgViewer
          @close="showImgViewer = false"
          @appDownloadImgCallback="appDownloadImgCallback"
          @slideChange="slideChange"
          @handleRight="showImgViewer = false"
          :topNotOverflow="true"
          :config="{
            list: imgViewerList,
            show: showImgViewer,
            zoom: true,
            loop: false,
            index: imgViewerIndex,
            hideDownloadIcon: true
          }"
          :rightBtn="true"
        >
          <template slot="closeIcon">
            <div class="close-viewer"></div>
          </template>
          <template slot="rightBtn">
            <div class="close-viewer">关闭</div>
          </template>
        </imgViewer>

        <serviceEntrance ref="serviceEntrance" :blank="true" />
      </template>
    </div>
  </div>
</template>

<script>
import { Tab, Tabs, Dialog } from 'vant'
import { decodeUrlQuery } from 'app/frontend-lib/tools/utils'
import homepageHeaderTest from 'component/platform/homepage/common/homepageHeaderTest.vue'
import tabbar from 'component/platform/homepage/common/tabbar.vue'
import zxServiceList from 'component/platform/homepage/tabList/zxServiceList.vue'
import serviceList from 'component/platform/homepage/tabList/serviceList.vue' // 服务列表
import commonRateList from 'component/platform/homepage/tabList/commonRateList.vue' // 评价列表
import dynamicList from 'component/platform/homepage/tabList/dynamicList.vue' // 动态列表
import QaList from 'component/platform/homepage/tabList/qaList.vue' // 问答列表
import fmList from 'component/platform/homepage/tabList/fmList.vue' // FM列表
import articleList from 'component/platform/homepage/tabList/articleList.vue' // 文章列表
import storyList from 'component/platform/homepage/tabList/storyList.vue' // 故事列表
import Posters from 'component/platform/homepage/common/posters.vue' // 海报
import bottomBar from 'component/platform/homepage/common/bottomBar.vue'
import ad from 'component/consult/ad.vue'
import workroomForExpert from 'component/xlt/workroomForExpert.vue'
import directionScrollMixin from 'mixins/platfrom/directionScroll.js'
import zxToOrder from 'mixins/platfrom/zxToOrder.js'
import homepage from 'store/platform/homepage.js'
import homepageCalcHeightMixin from 'mixins/platfrom/homepage/calcHeightMixin.js'
import tabbarMixin from 'app/web/mixins/platfrom/homepage/tabbarMixin.js'
import homepageMixin from 'mixins/platfrom/homepageMixin.js'
import { EventBus } from 'component/platform/homepage/eventBus.js'
import { mapState, mapGetters } from 'vuex'
import expertXltMixin from 'mixins/xlt/expertXltMixin.js'
import {
  teacherBrowse,
  sendAutoReplyApi,
  bindPromote
} from 'api/platform/homepage.js'
import imgViewer from 'component/common/imgViewer.vue'
import { getItem } from 'utils/storage.js'
import serviceEntrance from 'lib/component/vue/serviceEntrance/index.vue'
import { track } from '@yxl/libs'
import banner from 'component/platform/homepage/common/banner.vue'
import zxpersonInfo from 'component/platform/homepage/consultTeacher/zxpersonInfo.vue'
import normalPersonInfo from 'component/platform/homepage/normalUser/personInfo.vue'
import AnimationLoadingWhale from 'component/common/AnimationLoadingWhale.vue'
import qsServiceList from 'component/platform/homepage/qingsuTeacher/qsServiceList.vue'
import personInfo from 'component/platform/homepage/common/personInfo.vue'

export default {
  mixins: [
    directionScrollMixin,
    zxToOrder,
    homepageCalcHeightMixin,
    tabbarMixin,
    expertXltMixin,
    homepageMixin
  ],
  dataStore: homepage,
  inject: ['reloadRouteComp'],
  async preFetch({ store, route }) {
    store.commit('setMeta', {
      title: +route.query.isXltMp === 1 ? '心乐土' : '壹心理'
    })
    return Promise.all([
      store.dispatch('homepage/fetchBasicInfo', {
        user_id: route.params.userId
      }),
      store.dispatch('homepage/fetchServiceInfo', {
        user_id: route.params.userId
      }),
      store.dispatch('homepage/fetchTalkVideo', {
        teacher_id: route.params.userId,
        size: 100,
        page: 1
      })
    ])
  },
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    zxServiceList,
    serviceList,
    dynamicList,
    QaList,
    fmList,
    articleList,
    storyList,
    bottomBar,
    tabbar,
    Posters, // 分享海报
    workroomForExpert,
    ad,
    imgViewer,
    serviceEntrance,
    banner,
    zxpersonInfo,
    homepageHeaderTest,
    AnimationLoadingWhale,
    commonRateList,
    qsServiceList,
    normalPersonInfo,
    personInfo
  },
  data() {
    return {
      nullTabbar: true,
      currentClassify: {},
      showImgViewer: false,
      imgViewerList: [],
      imgViewerIndex: 0,
      recommendTeacherList: [],
      isFromSmartRecommend: false,
      toZxOrderBtnColor: 'purple',
      isShowPage: false,
      abTestHomepageV3_5: false
    }
  },
  computed: {
    ...mapGetters(['isLogin', 'loginUser']),

    ...mapGetters({
      isConsultTeacher: 'homepage/isConsultTeacher',
      isPsychicCoach: 'homepage/isPsychicCoach',
      isQingtingTeacher: 'homepage/isQingtingTeacher',
      isNormalUser: 'homepage/isNormalUser'
    }),

    ...mapState('homepage', {
      basicInfo: 'basicInfo',
      basicInfoDisabled: 'basicInfoDisabled',
      userRelation: 'userRelation',
      consultUser: state => {
        const { consult_user = {} } = state.zxAdvancedInfo
        return consult_user
      },
      qingsuService: 'qingsuService',
      qingsuVisit: 'qingsuVisit'
    }),

    directionScrollMin() {
      return 700
    },
    pictureList() {
      const { album } = this.basicInfo
      return Array.isArray(album) ? album : []
    },
    parsedAvatar() {
      const { avatar } = this.basicInfo
      if (avatar) {
        return (
          avatar.split(/(!\d+)?\?/)[0] +
          `?x-oss-process=image/resize,w_200/blur,r_30,s_30`
        )
      }
      return ''
    },
    serviceClassifys() {
      const list = []
      if (this.isConsultTeacher) {
        list.push({
          name: '专业咨询',
          type: 'consult'
        })
      }
      if (this.isPsychicCoach) {
        list.push({
          name: '心探教练',
          type: 'psychic'
        })
      }
      return list
    },
    currentTab() {
      return this.$store.state.homepage.currentTab
    },
    authorUserId() {
      return this.$route.params.userId
    },
    isOwner() {
      return +this.loginUser.id === +this.$route.params.userId
    },
    talkVideoInfo() {
      console.log(
        this.$store.state.homepage.talkVideoInfo,
        'this.$store.state.homepage.talkVideoInfo'
      )
      return this.$store.state.homepage.talkVideoInfo
    },
    isVideo() {
      const { talk } = this.talkVideoInfo
      return talk && talk.length >= 1
    },
    isPhotoalbum() {
      const { album } = this.talkVideoInfo
      return (
        (album && album.length > 0) ||
        (this.pictureList && this.pictureList.length > 0)
      )
    },
    hideBgMask() {
      if (!this.abTestHomepageV3_5) {
        return false
      }
      const { album, talk } = this.talkVideoInfo
      return (album && album.length) || (talk && talk.length)
    }
  },
  watch: {
    serviceClassifys: {
      handler() {
        // 赋初始值
        if (
          this.serviceClassifys.length &&
          Object.keys(this.currentClassify).length === 0
        ) {
          this.currentClassify = this.serviceClassifys[0]
        }
      },
      immediate: true
    }
  },
  async mounted() {
    // 如果是倾听师
    if (this.isQingtingTeacher) {
      this.$store.dispatch('homepage/fetchQingsuVisit', {
        to_user_id: this.$route.params.userId
      })
      await this.$store.dispatch('homepage/fetchQingsuService', {
        user_id: this.$route.params.userId
      })
    }
    await this.fetchHomepageV3_5AbTest()
    this.$store.commit('homepage/RESET_IS_RATE_TAB')
    if (this.$route.query.fromSmartRecommend) {
      this.isFromSmartRecommend = true
      this.recommendTeacherList = getItem('questionnaire_teacher_list') || []
      const index = this.recommendTeacherList.findIndex(
        l => l.user_id === this.authorUserId
      )
      this.$nextTick(() => {
        const { zxsListWrap, zxs = [] } = this.$refs
        if (!zxsListWrap || !zxs[0]) return
        zxsListWrap.scrollLeft = index * zxs[0].clientWidth
      })
    }
    !EventBus._events.toZxOrder &&
      EventBus.$on('toZxOrder', params => {
        console.info('ready to order page:', params)
        this.toOrderPage(params)
      })
    !EventBus._events.toQingsuOrder &&
      EventBus.$on('toQingsuOrder', params => {
        this.toQingsuOrder(params)
      })
    // 个人主页支持咨询业务的内部渠道标识&外部渠道标识（渠道标识记录进cookie里，下单时记录到咨询订单里）。
    this.mixinSetCookie()

    this.fetchUserRelatedInformation()
    this.fetchListInformation()
    this.$store.dispatch('homepage/fetchUserRelation', {
      user_id: this.authorUserId
    })
    const { avatar, album, nickname } = this.basicInfo
    this.imgViewerList = this.isConsultTeacher
      ? [
          {
            img: avatar,
            text: `${nickname}咨询师-个人头像`
          },
          ...album.map(img => ({
            img,
            text: `${nickname}咨询师-相册`
          }))
        ]
      : [
          {
            img: avatar,
            text: `${nickname}用户-个人头像`
          }
        ]
    if (this.mixinIsApp) {
      this.$bridge.switchNavigationBar({
        isHidden: 1
      })
      this.$bridge.isPullRefreshEnable({ enable: 0 })
    }
    const { tabbar, fromQingSuPage } = this.$route.query
    tabbar === 'evaluate' &&
      this.$refs.Tabbar?.onTabChange({
        name: 'evaluate',
        title: '评价'
      })
    // 从倾诉师列表过来直接选中倾诉tab
    if (+fromQingSuPage === 1) {
      const tab = this.mixinTabList.find(tab => tab.name === 'qingsu')
      tab && this.$store.commit('homepage/SET_CURRENT_TAB', tab)
    }
    window.addEventListener('appWebviewShow', this.prefetchInit)

    // if (this.isConsultTeacher) {
    //   this.$track.startHeatMap(
    //     {
    //       click: true,
    //       stay: true
    //     },
    //     {
    //       $title: '咨询师主页-' + nickname
    //     }
    //   )
    // }

    // 倾诉师站外推广绑定
    if (this.currentTab.name === 'qingsu' && this.$route.query.fromPromote)
      this.bindPromote()
  },
  beforeDestroy() {
    window.removeEventListener('appWebviewShow', this.prefetchInit)
    this.clearAutoReplyTimer()
    // this.$track.stopHeatMap()
  },
  methods: {
    bindPromote() {
      return bindPromote({
        to_user_id: this.$route.params.userId
      })
    },
    prefetchInit() {
      this.$store.dispatch('homepage/fetchBasicInfo', {
        user_id: this.$route.params.userId
      })
      this.$store.dispatch('homepage/fetchServiceInfo', {
        user_id: this.$route.params.userId
      })
      this.$store.dispatch('homepage/fetchQingsuService', {
        user_id: this.$route.params.userId
      })
    },
    async changeZXS(userId, i) {
      this.$trackEvent('newprofilepages_recommendation_switch', {
        item_location: i
      })
      if (!userId || this.$route.params.userId === userId) return
      const loading = this.$loading()
      await this.$router.replace({
        path: `/homepage/${userId}`,
        query: { ...this.$route.query, tabbar: '' }
      })
      this.reloadRouteComp()
      // 切换老师跳服务tab
      this.$store.commit('homepage/SET_CURRENT_TAB', this.mixinTabList[0])
      setTimeout(() => loading.close(), 0)
    },
    // 用户相关信息
    async fetchUserRelatedInformation() {
      Promise.all([
        this.$store.dispatch('getUserInfo'),
        this.isConsultTeacher
          ? this.$store.dispatch('homepage/fetchConsultService', {
              is_xlt_mp: this.$route.query.isXltMp || '', // 代表是否心乐土心理咨询
              user_id: this.authorUserId,
              activity_id: this.$route.query.activity_id || '',
              coupon_id: this.$route.query.coupon_id || ''
            })
          : Promise.resolve()
        // this.$store.dispatch('homepage/fetchUserRelation', {
        //   user_id: this.authorUserId
        // })
      ]).finally(() => {
        this.calcMaskTop()
        this.calcHeights()
        this.isShowPage = true
        // 页面访问埋点
        this.pageStat()
        if (this.isConsultTeacher && this.isLogin) {
          // 如果是当前主页是咨询师，而且访客已登录---需上报浏览记录
          setTimeout(() => {
            teacherBrowse({ teacher_id: this.authorUserId })
          }, 1000)
          this.sendAutoReply()
          window.addEventListener('appWebviewHide', this.clearAutoReplyTimer)
        }
      })
    },
    // 列表信息
    fetchListInformation() {
      this.mixinGetToken().then(token => {
        this.token = token
        Promise.all([
          this.$store.dispatch('homepage/fetchDynamicList', {
            token: this.token,
            pageNo: 1,
            pageSize: 20,
            userId: this.authorUserId,
            objectType: 1
          }),
          this.$store.dispatch('homepage/fetchBusinesses', {
            user_id: this.authorUserId,
            token: this.token,
            page: 1,
            size: 20
          }),
          // 只看有内容
          this.getRatelist(1).then(({ code, data }) => {
            if (+code === 0) {
              this.$store.commit(
                'homepage/SET_SERVICE_TAB_RATE_LIST',
                data?.list || []
              )
              // 没有有内容 查没有内容
              if (!data?.list.length) {
                this.$store.commit('homepage/SET_CURRENT_RATE_TYPE', 0)
                this.getRatelist(0)
              }
            }
          }),
          this.isQingtingTeacher ? this.getQingsuRateList(1) : Promise.resolve()
        ]).finally(() => {
          // 一个tab都没有，需显示缺省图
          this.nullTabbar = !!this.mixinTabList.length
          // 判断激活哪个tab
          this.mixinHighLightFirstTab()
          if (
            this.mixinTabList.length &&
            this.mixinTabList[0].name === 'qingsu'
          ) {
            this.$nextTick(() => {
              this.calcMaskTop()
              this.calcHeights()
            })
          }
        })
      })
    },
    onTypeChange(type) {
      this.$trackEvent('newprofilepages_service_tab_click', {
        button_name: type.name
      })
      this.currentClassify = type
    },
    pageStat() {
      const toUserStatus = this.isNormalUser
        ? ['普通用户']
        : [
            this.isPsychicCoach ? '心探教练' : '',
            this.isQingtingTeacher ? '倾听师' : '',
            this.isConsultTeacher ? '咨询师' : ''
          ]
      const { channel_flag = '', cid = '' } = this.$route.query
      const {
        consult_new_user = '',
        teacher_new_visit = '',
        consult_new_visit = ''
      } = this.consultUser

      try {
        this.$trackPageView('newprofilepages_view', {
          is_login: this.isLogin,
          is_follow: +this.userRelation.follow === 1,
          to_user_status: toUserStatus.filter(v => !!v),
          is_newconsultuser: +consult_new_user === 1, // 是否咨询新用户
          is_newteachervisitor: +teacher_new_visit === 1, // 是否咨询师新来访
          is_newconsultvisitor: +consult_new_visit === 1, // 是否咨询新来访
          channel_flag,
          cid,
          psychologist_id: this.isConsultTeacher ? this.authorUserId : '',
          psychologist_name: this.isConsultTeacher
            ? this.basicInfo.nickname
            : '',
          is_intelligentrecommendation: this.isFromSmartRecommend,
          to_user_id: this.authorUserId || '',
          is_video: this.isVideo,
          is_photoalbum: this.isPhotoalbum,
          is_newlistenvisitor: this.qingsuVisit.is_new_visit,
          is_newlistenervisitor: this.qingsuVisit.is_new_teacher_visit,
          listener_id: this.authorUserId || '',
          listener_name: this.basicInfo.nickname,
          listener_state: this.isQingtingTeacher
            ? ['已休息', '空闲', '服务中'][this.qingsuService.info.ting_status]
            : undefined
        })
      } catch (error) {
        console.log(error)
      }
    },
    async toOrderPage({
      cid = '',
      auto_show_selector = '',
      way = '',
      coupon_id = '',
      activity_id = ''
    } = {}) {
      const opts = {
        to_user_id: this.$route.params.userId,
        tjgw: this.$route.query.tjgw || '',
        cid,
        auto_show_selector,
        way,
        coupon_id,
        activity_id
      }

      // 如果从个人主页跳到下单页面，下单页的来源页面取当前页的 source_page 来记录
      if (this.$route.query._source_page_) {
        opts._source_page_ = this.$route.meta.pageName
          ? decodeUrlQuery(this.$route.query._source_page_) +
            '-' +
            this.$route.meta.pageName
          : this.$route.query._source_page_
      }

      // 心乐土工作室id
      if (this.mixinShowStudioInfo) {
        Object.assign(opts, {
          xlt_studio_id: this.mixinStudio.id
        })
      }
      this.mixinToZxOrder(opts)
    },
    async sendLetter() {
      this.$trackEvent('newprofilepages_whisper', {})
      await this.$store.dispatch('getUserInfo')
      if (!this.isLogin) {
        this.toLogin()
        return
      }

      if (this.isOwner) {
        this.$toast({
          text: '不能私信自己',
          zIndexTop: true
        })
        return
      }
      if (!this._checkBlock()) {
        return
      }

      this.$trackEvent('newprofilepages_whisper_suceess', {})
      if (this.$platform.isYixinliApp) {
        window.location.href = `yixinli://open_chat?user_id=${this.authorUserId}`
      } else {
        this.routerPush(
          `https://m.xinli001.com/user/message-chat/${this.authorUserId}?hideNav=true`
        )
      }
    },
    async toggleFollow(autoCancel) {
      // 点击关注按钮埋点
      if (+this.userRelation.follow !== 1) {
        this.$trackEvent('newprofilepages_follow', {})
      }

      await this.$store.dispatch('getUserInfo')
      if (!this.isLogin) {
        this.toLogin()
        return
      }

      if (+this.userRelation.follow === 1) {
        // 自动取消关注
        if (autoCancel) {
          this.mixinToggleFollow(autoCancel)
          return
        }
        // 手动取消关注
        Dialog.confirm({
          message: '是否取消关注？',
          className: 'homepage-vant-dialog-style',
          confirmButtonText: '继续关注',
          cancelButtonText: '取消关注'
        })
          .then(() => {
            // on confirm
          })
          .catch(() => {
            this.mixinToggleFollow()
          })
        return
      }

      // 关注
      if (this.isOwner) {
        this.$toast({
          text: '不能关注自己',
          zIndexTop: true
        })
        return
      }
      if (!this._checkBlock()) {
        return
      }
      this.mixinToggleFollow()
    },
    _checkBlock() {
      if (+this.userRelation.in_own_blacklist === 1) {
        this.$toast({
          text: '已拉黑对方，无法操作',
          zIndexTop: true
        })
        return
      }
      if (+this.userRelation.in_other_party_blacklist === 1) {
        // 被对方拉黑
        this.$toast({
          text: '因对方设置，无法操作',
          zIndexTop: true
        })
        return
      }
      return true
    },
    // 获取评价列表
    getRatelist(type) {
      return this.$store.dispatch('homepage/fetchRatelist', {
        teacher_id: this.$route.params.userId,
        page: 1,
        type: type
      })
    },
    // 获取倾诉评价列表
    getQingsuRateList(type) {
      return this.$store.dispatch('homepage/fetchQingsuRate', {
        user_id: this.$route.params.userId,
        have_content: type,
        page: 1,
        size: 20
      })
    },
    // 打开分享海报
    openSharePosterModal() {
      this.$refs.posters.openSharePosterModal()
    },
    // 分享链接
    shareLink() {
      const { avatar, honor, nickname } = this.basicInfo
      const shareConfig = {
        imgUrl: avatar,
        title: `${nickname}-壹心理认证心理咨询师`,
        desc: honor,
        link: window.location.href
      }
      this.$bridge.shareReport(shareConfig)
    },
    share() {
      this.isConsultTeacher ? this.shareLink() : this.openSharePosterModal()
    },
    // 咨询师主页停留五秒发私信
    sendAutoReply() {
      this.autoReplyTimer = setTimeout(() => {
        sendAutoReplyApi({
          to_user_id: this.authorUserId
        })
      }, 5000)
    },
    clearAutoReplyTimer() {
      this.autoReplyTimer && clearTimeout(this.autoReplyTimer)
    },
    handleShowImgViewer(index = 0) {
      this.showImgViewer = true
      this.imgViewerIndex = index
    },
    appDownloadImgCallback() {
      this.$trackEvent('newprofilepages_photoalbum_save', {})
    },
    slideChange(index) {
      this.$trackEvent('newprofilepages_photoalbum_largerversion', {
        item_location: index + 1
      })
    },
    // 智能推荐重新答题
    resetSmartRecommend() {
      this.$trackEvent('newprofilepages_recommendation_restart')
      const url = `${window.location.origin}/consult/questionnaire${window.location.search}&step=1`
      if (this.$platform.isYixinliApp) {
        this.$bridge.openWebView({
          url,
          isCurrentPageOpen: 0,
          hideNavigationBar: 1
        })
      } else {
        window.location.href = url
      }
    },
    toHeCong() {
      this.$trackEvent('newprofilepages_recommendation_consultant')
      this.$refs.serviceEntrance.openDialog()
    },
    // 倾听师主页 abTest
    fetchQingTingAbTest() {
      const { isYixinliApp } = this.$platform
      return (isYixinliApp
        ? track().fetchAbtest({
            param_name: 'listenerhomepage_v4',
            default_value: 0,
            value_type: 'Number'
          })
        : Promise.resolve(0)
      ).then(result => {
        console.log(`listenerhomepage_v4`, result)
        if (this.$route.query.listenerhomepage_v4 !== undefined) {
          result = this.$route.query.listenerhomepage_v4
        }
        this.$store.commit('homepage/SET_HOMEPAGE_AB_RESULT', +result)
      })
    },
    //公共部分abTest
    fetchHomepageV3_5AbTest() {
      const { isYixinliApp } = this.$platform
      return (isYixinliApp
        ? track().fetchAbtest({
            param_name: 'zx_profile_v3_5',
            default_value: 0,
            value_type: 'Number'
          })
        : Promise.resolve(0)
      ).then(result => {
        if (this.$route.query.zx_profile_v3_5 !== undefined) {
          result = this.$route.query.zx_profile_v3_5
        }
        this.abTestHomepageV3_5 = !!+result
      })
    },
    toRate() {
      this.$refs.Tabbar.onTabChange({
        name: 'evaluate',
        title: '评价'
      })
    },
    getIsShowPanel(name) {
      return this.mixinTabList.find(item => item.name === name)
    },
    toQingsuOrder(params) {
      const { path, query } = params
      const { channel_flag, cid } = this.$route.query
      this.routerPush(
        {
          path,
          query: {
            ...query,
            channel_flag,
            cid
          }
        },
        `https://static.xinli001.com/msite/index.html`,
        true,
        'hash',
        true
      )
    }
  }
}
</script>

<style lang="scss">
@import '~style/platform/homepage/global.scss';
</style>

<style lang="scss" scoped>
@import '~style/platform/homepage/index.scss';
@import '~lib/scss/functions.scss';
.recommend-zx {
  padding-left: 32px;
  margin-bottom: 40px;
  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 200px;
    height: 48px;
    padding: 0 32px 0 20px;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 10px 32px 0 0;
    font-size: 20px;
    font-weight: 500;
    color: #ffffff;
    line-height: 48px;
    img {
      width: 24px;
      height: 24px;
    }
  }
  .zxs-list-wrap {
    width: 718px;
    height: 150px;
    background: rgba(255, 255, 255, 0.1);
    overflow: hidden;
    overflow-x: auto;
    border-radius: 0px 0px 0px 32px;
    padding: 16px 0 0 32px;
    box-sizing: border-box;
    ul {
      display: flex;
      align-items: center;
      li {
        box-sizing: border-box;
        padding-right: 40px;
        img {
          width: 64px;
          height: 64px;
          border-radius: 50%;
          padding: 8px;
          &.active {
            padding: 6px;
            border: 1px solid #6982fa;
          }
        }
        .name {
          width: 70px;
          font-size: 22px;
          font-weight: 400;
          color: #ffffff;
          text-align: center;
          line-height: 40px;
          @include limitLine(1);
        }
        &.btn {
          position: relative;
          .top {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 64px;
            height: 64px;
            background: #6982fa;
            border-radius: 50%;
            margin: 0 auto;
            img {
              width: 32px;
              height: 32px;
            }
          }
          &:last-of-type {
            .top {
              background: #ffa202;
            }
          }
          span {
            display: inline-block;
            width: 120px;
            font-size: 22px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            line-height: 22px;
            text-align: center;
            margin-top: 16px;
          }
          &.divider {
            padding-left: 40px;
            &:before {
              display: block;
              content: '';
              width: 1px;
              height: 102px;
              background: #fff;
              position: absolute;
              left: 0;
              top: -6px;
              opacity: 0.2;
            }
          }
        }
      }
    }
  }
}
.recommend-zx-test {
  background-color: #21252d;
  margin-bottom: 0px;
  padding-bottom: 20px;
  .title {
    background: rgba(67, 76, 92, 0.4);
  }
  .zxs-list-wrap {
    background: rgba(67, 76, 92, 0.4);
  }
}
.close-viewer {
  display: flex;
  align-items: center;
  color: #fff;
  padding-left: 30px;
  font-size: 28px;
  img {
    margin-right: 5px;
  }
}
.home-page-wrp {
  .content-inner-new {
    overflow: visible !important;
    position: absolute;
    margin-top: -30px;
    // z-index: 2;
    padding-bottom: 300px !important;
  }
  .before-mask.abTestV3_5 {
    background: #f7f7f7;
  }
}
</style>
